<template>
    <b-dropdown
        aria-role="menu"
        class="dropdown-listed dropdown-projects"
        :mobile-modal="false"
        @active-change="addFocus"
        :disabled="disabled">
        <a
            :class="['button', isCancel ? 'is-cancel' : 'is-cancel is-outlined']"
            slot="trigger"
            :style="triggerStyle ? triggerStyle.a : null">
            <template v-if="selectedValue">
                <span class="code tag mr5-xs" :style="triggerStyle ? triggerStyle.code : null">
                    {{ code }}
                </span>
                <span class="name">{{ name }}</span>
            </template>
            <template v-else
                ><span class="name">{{ name }}</span></template
            >
            <span class="icon angle-down">
                <font-awesome-icon :icon="['fas', 'angle-down']" />
            </span>
        </a>
        <b-dropdown-item aria-role="menu-item" custom>
            <textInput type="SEARCH" v-model="searchTerm" @input="doSearch" ref="search" />
        </b-dropdown-item>
        <template v-if="isSearching">
            <div class="head">
                <span v-if="count" class="mr5-xs">{{ count }}</span>
                {{ $t('searchResults') }}
            </div>
            <b-dropdown-item aria-role="menu-item" v-if="isLoading" class="is-info">
                <loader :text="$t('searching')" />
            </b-dropdown-item>
            <b-dropdown-item aria-role="menu-item" v-if="data && data.length == 0 && !isLoading" class="is-info">{{
                $t('noProjectsFound')
            }}</b-dropdown-item>
            <template v-if="data && data.length > 0">
                <b-dropdown-item aria-role="menu-item" :key="index" v-for="(item, index) in data" has-link>
                    <a href="javascript:void(0)" @click.prevent="onClick(item)">
                        <span
                            class="tag mr5-xs"
                            :style="`background-color:${stringToHslColor({ str: item.name })};color:#fff;`">
                            {{ item.code }}
                        </span>
                        {{ item.name }}
                    </a>
                </b-dropdown-item>
            </template>
            <pagination :count="count" v-model="pagination" :hidePerPage="true"></pagination>
        </template>
        <template v-if="!isSearching && recentItems.length > 0">
            <div class="head">{{ $t('recentProjects') }}</div>
            <b-dropdown-item aria-role="menu-item" :key="index" v-for="(item, index) in recentItems" has-link>
                <a href="javascript:void(0)" @click.prevent="onClick(item)">
                    <span
                        v-if="item.meta.code"
                        class="tag mr5-xs"
                        :style="`background-color:${stringToHslColor({ str: item.meta.title })};color:#fff;`">
                        {{ item.meta.code }}
                    </span>
                    <template v-if="item.meta">{{ item.meta.title }}</template>
                </a>
            </b-dropdown-item>
        </template>
        <template v-if="selectedValue">
            <hr class="dropdown-divider" aria-role="menuitem" />
            <b-dropdown-item aria-role="menu-item" @click="clear">
                <span class="icon">
                    <font-awesome-icon :icon="['fas', 'times']" />
                </span>
                <span> {{ $t(this.label) }} </span>
            </b-dropdown-item>
        </template>
    </b-dropdown>
</template>
<script>
import paginationMixin from './../mixins/pagination.js';
import { stringToHslColor } from './../mixins/helpers.js';

import { getProjects } from './../services/projects.js';

export default {
    name: 'ProjectSelect',
    components: {},
    props: ['value', 'disabled', 'isCancel', 'label', 'colouredTrigger'],
    mixins: [paginationMixin],
    data() {
        return {
            selectedValue: null,
            data: null,
            isLoading: false,
            searchTerm: '',
            isSearching: false,
            recentItems: [],
        };
    },
    computed: {
        currentUser() {
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            if (currentUser) {
                currentUser.id = currentUser.Id;
            }
            return currentUser;
        },
        name() {
            if (this.selectedValue) {
                if (this.selectedValue.name) {
                    //based on search
                    return this.selectedValue.name;
                } else if (this.selectedValue?.meta?.title) {
                    //recent
                    return this.selectedValue.meta.title;
                }
            }
            return this.label ? this.label : this.$t('chooseProject');
        },
        code() {
            if (this.selectedValue) {
                if (this.selectedValue.code) {
                    //based on search
                    return this.selectedValue.code;
                } else if (this.selectedValue?.meta?.code) {
                    //recent
                    return this.selectedValue.meta.code;
                }
            }
            return this.$t('chooseProject');
        },
        remainingItems() {
            return this.count - this.perPage;
        },
        triggerStyle() {
            var a = null;
            var code = null;
            if (this.selectedValue) {
                if (this.colouredTrigger) {
                    a = `background:${stringToHslColor({ str: this.name })};color:#fff;border:0;`;
                    code = `color:${stringToHslColor({ str: this.name })};background-color:#fff;`;
                } else {
                    code = `background:${stringToHslColor({ str: this.name })};color:#fff;border:0;`;
                }
            }
            return {
                a: a,
                code: code,
            };
        },
    },
    watch: {
        value() {
            this.handleValue();
        },
        searchTerm() {
            if (!this.searchTerm) {
                this.clearSearch();
            } else {
                this.doSearch();
            }
        },
    },
    created() {
        this.handleValue();
        this.fetchData();
        this.fetchRecentItems();
        if (this.recentItems && this.recentItems.length == 0) {
            this.isSearching = true;
        }
    },
    methods: {
        stringToHslColor,
        addFocus(active) {
            if (active) {
                this.$nextTick(() => {
                    this.$refs.search.$el.querySelector('input').focus();
                });
            }
        },
        handleValue() {
            this.selectedValue = this.value;
        },
        paginateChange(newPagination) {
            this.fetchData(newPagination);
        },
        fetchRecentItems() {
            if (this.currentUser) {
                var recentItems = JSON.parse(localStorage.getItem('vuex'));
                if (recentItems) {
                    recentItems =
                        recentItems.detailmenu && recentItems.detailmenu.recentList
                            ? recentItems.detailmenu.recentList[
                                  `${this.currentUser.Id}-${this.currentUser.workspace.id}`
                              ]
                            : null;
                    this.recentItems = recentItems
                        ? recentItems.filter((item) => {
                              return item.type == 'PROJECT';
                          })
                        : [];
                }
            } else {
                this.recentItems = [];
            }
        },
        fetchData(pagination = this.pagination) {
            this.isLoading = true;

            let payload = {
                page: pagination.currentPage,
                itemsPerPage: pagination.perPage,
                searchTerm: this.searchTerm,
                sortField: 'name',
                sortOrder: 'asc',
            };

            getProjects(payload).then((response) => {
                this.data = response.data;
                this.count = response.count;
                this.isLoading = false;
            });
        },
        clear() {
            this.selectedValue = null;
            this.$emit('input', null);
        },
        onClick(item) {
            this.selectedValue = item;
            this.$emit('input', item);
            this.searchTerm = null;
            if (item) {
                var meta = null;
                if (item.meta) {
                    meta = item.meta;
                } else {
                    meta = { title: item.name, code: item.code };
                }
                document.dispatchEvent(
                    new CustomEvent('showDetailObject', {
                        detail: {
                            id: item.id,
                            type: 'PROJECT',
                            showMenu: false,
                            meta: meta,
                        },
                    })
                );
            }
            this.fetchRecentItems();
        },
        doSearch() {
            if (this.searchTerm && this.searchTerm.length >= 3) {
                this.isSearching = true;
                this.currentPage = 0;
                this.fetchData();
            }
        },
        clearSearch() {
            this.count = this.recentItems.length;
            this.isSearching = false;
            this.searchTerm = '';
            this.currentPage = 0;
        },
    },
    i18n: {
        messages: {
            en: {
                searchResults: 'Search results',
                searching: 'Searching',
                noProjectsFound: 'Nothing found',
                recentProjects: 'Recent',
                chooseProject: 'Choose',
                clearSelection: 'Clear selection',
            },
            fr: {
                searchResults: 'Résultats de recherche',
                searching: 'Recherche en cours',
                noProjectsFound: 'Aucun trouvé',
                recentProjects: 'Récents',
                chooseProject: 'Choisir',
                clearSelection: 'Effacer la sélection',
            },
            nl: {
                searchResults: 'Zoekresultaten',
                searching: 'Bezig met zoeken',
                noProjectsFound: 'Niets gevonden',
                recentProjects: 'Recent',
                chooseProject: 'Kies ',
                clearSelection: 'Selectie wissen',
            },
        },
    },
};
</script>
